import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import type { UserSessionData } from 'noddi-web';
import { HomePageHeader } from '../components/HomePageHeader';
import { OrganizationMemberAccessInfo } from '../components/OrganizationMemberAccessInfo';
import { OrganizationMemberBookings } from '../components/OrganizationMemberBookings';
import { OrganizationMemberCars } from '../components/OrganizationMemberCars';
import { OrganizationMemberSettings } from '../components/OrganizationMemberSettings';
import { PendingBookingProposals } from '../components/PendingBookingProposals';

type Props = {
  userGroupId: number;
  userData: UserSessionData;
};

export const OrganizationMemberHomePage = ({ userGroupId, userData }: Props) => {
  const organization = userData.user.userGroups.find((userGroup) => userGroup.id === userGroupId);

  return (
    <ContentWrapperCustomerApp hideBackButton width='lg'>
      <div className='flex flex-col gap-6 md:gap-10'>
        <HomePageHeader userData={userData} isFirstTimeCustomer={false} />
        {/* No data-quality report here: this page is the plain member's, and an
            organization is reported to its admins alone. */}
        {organization?.name && (
          <OrganizationMemberAccessInfo
            userGroupId={userGroupId}
            organizationName={organization.name}
            holdsExternalCars={organization.holdsExternalCars}
          />
        )}
        {/* The server narrows a member's proposals to the ones addressed to them or for cars they manage. */}
        <PendingBookingProposals userGroupId={userGroupId} />
        <OrganizationMemberCars userGroupId={userGroupId} />
        <OrganizationMemberBookings userGroupId={userGroupId} />
        <OrganizationMemberSettings userGroupId={userGroupId} />
      </div>
    </ContentWrapperCustomerApp>
  );
};
